import types from './types';

const INITIAL_STATE = {
  isAppLoading: false,
  isMiniAppLoading: false,
  data: null,
  alertData: null,
  checkoutDataTemp: null,
  isTestMode: false,
  featureFlag:null,
}

const appReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_APP_LOADER: {
      return {
        ...state,
        isAppLoading: action.value
      }
    }
    case  types.SET_FeatureFlag:{
      return {
        ...state,
        featureFlag: action.value
      }
    }
    case types.SET_MINI_APP_LOADER: {
      return {
        ...state,
        isMiniAppLoading: action.value
      }
    }
    case types.Alert: {
      state = {
        ...state,
        alertData: action.data

      }
    }
    case types.Mem_Step1: {
      state = {
        ...state,
        data: action.data

      }
    }
    case types.Mem_Step2: {
      state = {
        ...state,
        data: action.data

      }
    }
    case types.SET_TEMP_DATA: {
      state = {
        ...state,
        checkoutDataTemp: action.value

      }
    }
    case types.SET_TEST_MODE: {
      state = {
        ...state,
        isTestMode: action.value
      }
    }
    default: return state;
  }
}

export default appReducer;